/**
 * Feature flags — flip a single flag to park/un-park a feature suite.
 *
 * PARKED means: UI is hidden, but code/routes/endpoints stay intact.
 * Set to `false` to bring it back online.
 */
export const GANAPATHI_PARKED = true;
